import { IconExternalLink } from '@tabler/icons-react';
import { CardDetailsDto, EmployeeDto } from '@zorro/clients';
import { Button } from '@zorro/design-system/v2/Button';
import { Card } from '@zorro/design-system/v2/Card';
import { IconZorroBulb } from '@zorro/shared/assets';
import { Flex, Stack, Text } from '@zorro/web/design-system';

import {
  PaymentNoteInfoProps,
  getPaymentNoteText,
} from '../PaymentStatus/paymentNoteText.utils';
import { ZorroPayCardDetails } from './ZorroPayCardDetails';

const ZorroPayNote = ({
  paymentNoteInfo,
  isImpersonated = false,
}: {
  paymentNoteInfo: PaymentNoteInfoProps;
  isImpersonated?: boolean;
}) => (
  <Card px="md" py="lg" variant="grey">
    <Flex columnGap="xs" align="center" wrap="nowrap">
      <IconZorroBulb />
      <Stack>
        <Text size="sm">
          {getPaymentNoteText(paymentNoteInfo, isImpersonated)}
        </Text>
      </Stack>
    </Flex>
  </Card>
);

const RevealButton = ({
  onClick,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled: boolean;
}) => (
  <Button
    variant="secondary"
    size="sm"
    w="fit-content"
    py="md"
    onClick={onClick}
    disabled={isDisabled}
    rightSection={<IconExternalLink size={16} />}
  >
    View card details
  </Button>
);

type CardMethodSectionProps = {
  employeeId: EmployeeDto['id'];
  card: CardDetailsDto | null;
  isLoading: boolean;
  label: string;
  billingAddress?: string;
  paymentNoteInfo?: PaymentNoteInfoProps;
  isImpersonated?: boolean;
  onReveal?: () => void;
  isRevealDisabled?: boolean;
};

const CardMethodSection = ({
  employeeId,
  card,
  isLoading,
  label,
  billingAddress,
  paymentNoteInfo,
  isImpersonated,
  onReveal,
  isRevealDisabled = false,
}: CardMethodSectionProps) => (
  <Stack gap="1rem">
    <ZorroPayCardDetails
      employeeId={employeeId}
      card={card}
      isLoading={isLoading}
      label={label}
    />
    {billingAddress && (
      <Text size="sm">
        <Text component="span" fw="var(--font-weight-600)">
          Billing address:
        </Text>{' '}
        {billingAddress}
      </Text>
    )}
    {onReveal && (
      <RevealButton onClick={onReveal} isDisabled={isRevealDisabled} />
    )}
    {paymentNoteInfo && (
      <ZorroPayNote
        paymentNoteInfo={paymentNoteInfo}
        isImpersonated={isImpersonated}
      />
    )}
  </Stack>
);

export { CardMethodSection };
export type { CardMethodSectionProps };
